/* eRamis - schimba iconita de cos din header.
   Marcajul vine din sections/eramis-header.liquid, pe care nu-l modificam, asa ca
   inlocuim doar <svg>-ul la runtime. Bulina cu numarul de produse si eticheta "Cos"
   raman neatinse - sunt fratii lui in acelasi buton.

   CA SA SCHIMBI MODELUL: schimba valoarea lui ALEGERE de mai jos. Atat.
   'carucior' - caruciorul clasic de supermarket. Cel mai usor de recunoscut.
   'poseta'   - poseta cu toarta si inchizatoare. Potrivita cu ce vinzi.
   'cos'      - cosul de cumparaturi, cu doua manere.
   'penar'    - penar cu fermoar. ATENTIE: nimeni nu il citeste ca fiind cosul de
                cumparaturi. Arata bine intr-o campanie de scoala, dar clientul care
                cauta unde i-au ajuns produsele nu se uita la el. */
(function(){
  'use strict';

  var ALEGERE = 'carucior';

  var A = 'fill="none" stroke="currentColor" stroke-width="1.6" stroke-linecap="round" stroke-linejoin="round"';

  var MODELE = {
    carucior:
      '<path d="M2.5 3.5h2.1l2.3 10.2a1.7 1.7 0 0 0 1.7 1.3h8.1a1.7 1.7 0 0 0 1.6-1.3L20 7.2H6"/>' +
      '<circle cx="9.5" cy="19.3" r="1.4"/><circle cx="17" cy="19.3" r="1.4"/>',
    poseta:
      '<path d="M5 8.6h14l1 9.1a2.1 2.1 0 0 1-2.1 2.3H6.1A2.1 2.1 0 0 1 4 17.7l1-9.1z"/>' +
      '<path d="M9 8.6V7.1a3 3 0 0 1 6 0v1.5"/><path d="M10.4 13.2h3.2"/>',
    cos:
      '<path d="M3 8.4h18l-1.6 9.2a2.1 2.1 0 0 1-2.1 1.8H6.7a2.1 2.1 0 0 1-2.1-1.8L3 8.4z"/>' +
      '<path d="M8.6 8.4 10.2 4"/><path d="M15.4 8.4 13.8 4"/>' +
      '<path d="M9.6 12.2v3.6"/><path d="M14.4 12.2v3.6"/>',
    penar:
      '<rect x="3" y="7" width="18" height="10.6" rx="3.2"/>' +
      '<path d="M3 12.3h18"/><circle cx="16.6" cy="14.9" r="1"/>'
  };

  function boot(){
    var btn = document.querySelector('.erh-cart');
    if(!btn || btn.dataset.erIcon === '1'){ return; }
    var vechi = btn.querySelector('svg');
    var desen = MODELE[ALEGERE];
    if(!vechi || !desen){ return; }
    btn.dataset.erIcon = '1';

    var nou = document.createElementNS('http://www.w3.org/2000/svg', 'svg');
    nou.setAttribute('width', vechi.getAttribute('width') || '22');
    nou.setAttribute('height', vechi.getAttribute('height') || '22');
    nou.setAttribute('viewBox', '0 0 24 24');
    nou.setAttribute('aria-hidden', 'true');
    /* atributele de contur le punem prin innerHTML pe un <g>, ca sa nu le repetam
       pe fiecare forma si sa ramana identice cu restul iconitelor din header */
    nou.innerHTML = '<g ' + A + '>' + desen + '</g>';
    vechi.parentNode.replaceChild(nou, vechi);
  }

  if(document.readyState === 'loading'){
    document.addEventListener('DOMContentLoaded', boot);
  } else {
    boot();
  }
  window.addEventListener('load', boot);
  document.addEventListener('shopify:section:load', boot);
})();
